import React from 'react';
import { cn } from '../../lib/utils';

const GenreFilter = ({ categories, active, onChange, className }) => (
  <div className={cn('-mx-1 overflow-x-auto py-2 no-scrollbar', className)}>
    <div className="flex gap-2 px-1">
      {categories.map((c) => {
        const isActive = active === c.id;
        return (
          <button
            key={c.id}
            type="button"
            onClick={() => onChange(c.id)}
            className={cn(
              'shrink-0 rounded-full px-4 py-1.5 text-sm font-medium transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background',
              isActive
                ? 'bg-[hsl(var(--kinora-card-hi))] text-foreground'
                : 'text-muted-foreground hover:bg-secondary/50 hover:text-foreground'
            )}
          >
            {c.name}
            {isActive && c.count > 0 && (
              <span className="ml-1.5 text-xs opacity-60 tabular-nums">
                {c.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  </div>
);

export default GenreFilter;
